import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { PageHeader } from "../../components/Layout";

export default function Leaderboard() {
  const [exams, setExams] = useState([]);
  const [selected, setSelected] = useState("");
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/exams").then((r) => {
      setExams(r.data);
      if (r.data[0]) setSelected(r.data[0].exam_id);
    });
  }, []);

  useEffect(() => {
    if (!selected) return;
    api.get(`/exams/${selected}/leaderboard`).then((r) => setItems(r.data));
  }, [selected]);

  return (
    <div>
      <PageHeader overline="Rankings" title="Leaderboard" subtitle="See how peers performed on each exam." />
      <div className="mb-6">
        <select
          value={selected}
          onChange={(e) => setSelected(e.target.value)}
          className="border border-zinc-300 px-3 py-2 text-sm bg-white focus:border-zinc-900 focus:outline-none"
          data-testid="leaderboard-exam-select"
        >
          {exams.map((e) => <option key={e.exam_id} value={e.exam_id}>{e.title}</option>)}
        </select>
      </div>
      <div className="border border-zinc-200" data-testid="leaderboard-table">
        <div className="grid grid-cols-12 px-5 py-3 border-b border-zinc-200 bg-zinc-50 text-[10px] uppercase tracking-[0.2em] text-zinc-500 font-semibold">
          <div className="col-span-1">Rank</div>
          <div className="col-span-5">Name</div>
          <div className="col-span-3">Score</div>
          <div className="col-span-3">Percentage</div>
        </div>
        {items.length === 0 ? (
          <div className="p-10 text-center text-sm text-zinc-500">No submissions yet for this exam.</div>
        ) : items.map((l) => (
          <div key={l.user_id} className="grid grid-cols-12 px-5 py-4 border-b border-zinc-200 last:border-b-0 items-center text-sm">
            <div className="col-span-1 font-mono-tab font-bold">#{l.rank}</div>
            <div className="col-span-5 font-medium">{l.name}</div>
            <div className="col-span-3 font-mono-tab">{l.score}</div>
            <div className="col-span-3 font-mono-tab">{l.percentage}%</div>
          </div>
        ))}
      </div>
    </div>
  );
}
